import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';
import TooltipContainer from '../TooltipContainer';

export default class ReloadButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.handleReload = this.handleReload.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.switchAction = this.switchAction.bind(this);
    }

    handleReload() {
        window.location.reload();
    }

    switchAction() {
        const {modalShow} = this.props;
        if (modalShow) return this.toggleModal();
        this.handleReload();
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    render() {
        return (
            <TooltipContainer component="button" className="btn btn-primary delete-button" type="button" onClick={this.switchAction}
                tooltip={messages.surveys.tooltips.dropChanges}>
                <Icon icon="trash" /> <FormattedMessage {...messages.surveys.button.drop_changes} />
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} >
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.surveys.modals.dropChanges.title} />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage {...messages.surveys.modals.dropChanges.body} />
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary delete-button" type="button" onClick={this.handleReload}>
                            <Icon icon="trash" /><FormattedMessage {...messages.surveys.button.drop_changes} />
                        </button>
                    </ModalFooter>
                </Modal>
            </TooltipContainer>
        );
    }
}
